import { useEffect } from 'react';

// ##### Hook to lock/unlock body scroll
// Prevents background scrolling when modals/drawers are open
// Also hides the scrollbar for better visual experience
const useScrollLock = (isLocked) => {
  useEffect(() => {
    if (isLocked) {
      // Lock scroll and hide scrollbar
      document.body.style.overflow = 'hidden';
    } else {
      // Restore scroll
      document.body.style.overflow = '';
    }

    // Cleanup: always restore scroll when component unmounts
    return () => {
      document.body.style.overflow = '';
    };
  }, [isLocked]);
};

export default useScrollLock;
